import { createChart } from "bi-sdk";

export const setLine1 = function (chartData, chartId) {
  let chart = createChart(
    {
      dataset: chartData,
      grid: {
        top: 30,
        right: 0
      },
      xAxis: {
        splitLine: {
          show: false
        }
      },
      yAxis: {
        axisLine: {
          show: false
        }
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          lineStyle: {
            color: "#E5E6EB"
          }
        },
        textStyle: {
          rich: {
            a: {
              color: "red"
            }
          }
        }
      },
      dataZoom: [
        {
          type: "inside"
        },
        {
          type: "slider",
          bottom: 7,
          height: 20,
          dataBackground: {
            lineStyle: {
              width: 1,
              color: "#E5E6EB"
            },
            areaStyle: {
              color: "#E8FFF8"
            }
          },
          fillerColor: "#F0F2F5",
          borderColor: "#E5E6EB",
          moveHandleSize: 6
          // moveHandleStyle: {
          //   color: "#B2EFE0",
          //   borderWidth: 0
          // },
          // emphasis: {
          //   moveHandleStyle: {
          //     color: "#B2EFE0"
          //   }
          // }
        }
      ],
      series: [
        {
          type: "line",
          smooth: false,
          lineStyle: {
            width: 2,
            color: "#55D46C"
          },
          areaStyle: {
            color: "rgba(0,0,0,0)"
          },
          symbolSize: 8,
          showSymbol: false,
          zlevel: 1,
          emphasis: {
            disabled: true,
            scale: false
          },
          itemStyle: {
            emphasis: {
              color: "#6AD6C7",
              borderWidth: 3,
              borderColor: "#fff",
              shadowBlur: 7,
              shadowOffsetY: 2,
              shadowColor: "rgba(167, 168, 215, 0.5)"
            }
          }
        }
      ]
    },
    { extend: ["title", "xAxis", "yAxis", "tooltip"] }
  );
  chart.amount(chartId);
  return chart;
};

export const setLine3 = function (chartData, chartId) {
  let chart = createChart(
    {
      dataset: chartData,
      grid: {
        top: 30,
        right: 0
      },
      xAxis: {
        splitLine: {
          show: false
        }
      },
      yAxis: {
        axisLine: {
          show: false
        }
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          lineStyle: {
            color: "#E5E6EB"
          }
        },
        textStyle: {
          rich: {
            a: {
              color: "red"
            }
          }
        }
      },
      series: [
        {
          type: "line",
          lineStyle: {
            width: 4,
            color: "#6AD6C7",
            cap: "round"
          },
          areaStyle: {
            color: "rgba(0,0,0,0)"
          },
          symbolSize: 8,
          showSymbol: false,
          zlevel: 1,
          emphasis: {
            disabled: true,
            scale: false
          },
          itemStyle: {
            emphasis: {
              color: "#6AD6C7",
              borderWidth: 3,
              borderColor: "#fff",
              shadowBlur: 7,
              shadowOffsetY: 2,
              shadowColor: "rgba(167, 168, 215, 0.5)"
            }
          }
        },
        {
          type: "line",
          lineStyle: {
            type: "dashed",
            width: 4,
            color: "#CCF7EB",
            cap: "round"
          },
          areaStyle: {
            color: "rgba(0,0,0,0)"
          },
          symbolSize: 8,
          showSymbol: false,
          emphasis: {
            disabled: true,
            scale: false
          },
          itemStyle: {
            emphasis: {
              color: "#6AD6C7",
              borderWidth: 3,
              borderColor: "#fff",
              shadowBlur: 7,
              shadowOffsetY: 2,
              shadowColor: "rgba(167, 168, 215, 0.5)"
            }
          },
          zlevel: 1
        },
        {
          type: "line",
          lineStyle: {
            width: 3,
            color: "rgba(255, 255, 255, 1)",
            shadowColor: "#6AD6C7",
            shadowBlur: 6,
            shadowOffsetY: 21,
            opacity: 0.25,
            z: 1
          },
          areaStyle: {
            color: "none"
          },
          symbolSize: 8,
          showSymbol: false,
          emphasis: {
            disabled: true,
            scale: false
          },
          itemStyle: {
            emphasis: {
              color: "#6AD6C7",
              borderWidth: 3,
              borderColor: "#fff",
              shadowBlur: 7,
              shadowOffsetY: 2,
              shadowColor: "rgba(167, 168, 215, 0.5)"
            }
          }
        }
      ]
      // dataSet: chartData
    },
    { extend: ["title", "xAxis", "yAxis", "tooltip"] }
  );
  // chart.dataSet(chartData);
  chart.amount(chartId);
  return chart;
};

export const setLineStatisticsConsumption = function (chartData, chartId) {
  let chart = createChart(
    {
      dataset: chartData,
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "none"
        },
        padding: [8, 12],
        formatter(params) {
          return `
          <div class="tooltip-foomatter">
            <div class="date">${params[0].axisValue}</div>
            ${params
              .map((item, index) => {
                return `
                  <div class="item"><div class="icon" style="background-color:${
                    item.color
                  }"></div>${item.seriesName}：
                  ${item.value[index + 1]}${index == 1 ? "%" : ""}</div>
              `;
              })
              .join("")}
            </div>
          `;
        }
      },
      legend: {
        itemGap: 28,
        itemWidth: 10,
        itemHeight: 1,
        left: "center",
        textStyle: {
          color: "#86909C",
          padding: [0, 0, 0, 6]
        }
      },
      grid: {
        top: 50,
        left: 50,
        right: 50,
        bottom: 80
      },
      dataZoom: [
        {
          type: "slider",
          realtime: true,
          backgroundColor: "#F0F2F5",
          start: 0,
          end: 100,
          dataBackground: {
            lineStyle: {
              color: "#F0F2F5"
            },
            areaStyle: {
              opacity: 0
            }
          },
          selectedDataBackground: {
            lineStyle: {
              color: "#CED4D9"
            },
            areaStyle: {
              color: "#F0F2F5"
            }
          }
        }
      ],
      yAxis: [
        {
          type: "value",
          splitLine: {
            lineStyle: {
              color: "#E5E6EB",
              type: "dashed"
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#86909C"
          }
        },
        {
          type: "value",
          position: "right",
          splitLine: {
            lineStyle: {
              color: "#E5E6EB"
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#86909C",
            formatter: "{value} %"
          }
        }
      ],
      xAxis: {
        boundaryGap: false,
        alignTicks: true,
        splitLine: {
          show: false
        },
        axisLabel: {
          color: "#86909C"
        },
        axisTick: {
          show: true,
          length: 4,
          lineStyle: {
            color: "#E5E6EB"
          }
        },
        axisLine: {
          lineStyle: {
            color: "#E5E6EB"
          }
        }
      },
      animation: true,
      series: [
        {
          type: "line",
          name: "用量",
          smooth: false,
          showSymbol: false,
          itemStyle: {
            color: "#8D95F6"
          },
          lineStyle: {
            width: 2,
            cap: "round"
          },
          areaStyle: {
            color: "none"
          }
        },
        {
          type: "line",
          name: "错误率",
          smooth: false,
          showSymbol: false,
          yAxisIndex: 1,
          itemStyle: {
            color: "#F56C68"
          },
          lineStyle: {
            width: 2,
            cap: "round"
          },
          areaStyle: {
            color: "none"
          }
        }
      ]
    },
    { extend: ["title", "xAxis", "yAxis", "tooltip", "grid", "legend"] }
  );
  chart.amount(chartId);
  return chart;
};

export const monitorLine = function (chartData, chartId) {
  let chart = createChart(
    {
      dataset: chartData,
      dataZoom: [
        {
          type: "slider",
          realtime: true,
          backgroundColor: "#F0F2F5",
          start: 0,
          end: 20,
          dataBackground: {
            lineStyle: {
              color: "#F0F2F5"
            },
            areaStyle: {
              opacity: 0
            }
          },
          selectedDataBackground: {
            lineStyle: {
              color: "#CED4D9"
            },
            areaStyle: {
              color: "#F0F2F5"
            }
          }
        }
      ],
      grid: {
        top: 50,
        left: 30,
        right: 30,
        bottom: 70
      },
      legend: {
        type: "plain",
        bottom: "auto",
        left: "center",
        top: 30,
        itemGap: 36,
        itemWidth: 10,
        itemHeight: 1
      },
      xAxis: {
        splitLine: {
          show: false
          // type: "dotted"
        },
        boundaryGap: false
      },
      yAxis: [
        {
          type: "value",
          max: 75,
          interval: 15,
          splitNumber: 6,
          splitLine: {
            lineStyle: {
              color: ["rgba(128, 151, 177, 0.25)"],
              type: "dashed"
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        }
      ],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "none"
        },
        formatter(params) {
          return `
          <div class="tooltip-foomatter">
            <div class="date">${params[0].axisValue}</div>
            ${params
              .map((item, index) => {
                return `
                  <div class="item"><div class="icon" style="background-color:${
                    item.color
                  }"></div>${item.seriesName}：
                  ${item.value[index + 1]}</div>
              `;
              })
              .join("")}
            </div>
          `;
        }
      },
      series: [
        {
          type: "line",
          smooth: false,
          showSymbol: false,
          yAxisIndex: 0,
          itemStyle: {
            color: "#5D65FB"
          },
          emphasis: {
            lineStyle: {
              width: 2
            }
          },
          areaStyle: {
            color: "none"
          }
        },
        {
          type: "line",
          smooth: false,
          showSymbol: false,
          yAxisIndex: 0,
          itemStyle: {
            color: "#FDA64A"
          },
          emphasis: {
            lineStyle: {
              width: 2
            }
          },
          areaStyle: {
            color: "none"
          }
        },
        {
          type: "line",
          smooth: false,
          showSymbol: false,
          yAxisIndex: 0,
          itemStyle: {
            color: "#0BB837"
          },
          emphasis: {
            lineStyle: {
              width: 2
            }
          },
          areaStyle: {
            color: "none"
          }
        }
      ]
      // dataSet: chartData
    },
    { extend: ["title", "xAxis", "yAxis", "tooltip"] }
  );
  // chart.dataSet(chartData);
  chart.amount(chartId);
  return chart;
};

export const setRateLine = function (chartData, color, linearGradient, chartId) {
  let chart = createChart(
    {
      xAxis: {
        show: false,
        type: "category",
        boundaryGap: false
      },
      tooltip: {
        show: false
      },
      grid: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      },
      yAxis: {
        show: false,
        type: "value",
        boundaryGap: false
      },
      series: {
        type: "line",
        itemStyle: {
          color: color
        },
        smooth: true,
        lineStyle: {
          width: 1,
          cap: "round"
        },
        areaStyle: {
          color: {
            type: "linear",
            colorStops: [
              {
                offset: 0,
                color: linearGradient.color1
              },
              {
                offset: 1,
                color: linearGradient.color2
              }
            ],
            global: false
          }
        },
        symbolSize: 0,
        data: [623, 135, 842, 788, 400, 588, 455, 700]
      }
    },
    { extend: ["grid"] }
  );
  chart.amount(chartId);
  return chart;
};

export const setCaseSharingLine = function (chartData, chartId) {
  let riseIcon = require("@/assets/img/rise_icon.png");
  // declineIcon = require("@/assets/img/decline_icon.png"),
  let chart = createChart(
    {
      grid: {
        top: 20,
        left: 0,
        right: 20,
        bottom: 0
      },
      yAxis: [
        {
          type: "category",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            color: "#1D2129",
            fontWeight: "400",
            fontSize: 14,
            padding: [0, 0, 14, 0],
            verticalAlign: "bottom"
          },
          offset: -65
        },
        {
          type: "category",
          data: [8.6, 7.5, 8.6, 8.6],
          axisLabel: {
            show: true,
            color: "#1D2129",
            fontWeight: "bold",
            fontSize: 18,
            padding: [0, 0, 10, 0],
            verticalAlign: "bottom"
          },
          axisLine: {
            show: false
          },
          offset: -35,
          axisTick: {
            show: false
          }
        },
        {
          type: "category",
          data: [4, 3, 2, 1],
          axisLabel: {
            show: true,
            padding: [0, 0, 14, 0],
            verticalAlign: "bottom",
            color: "#1D2129",
            formatter: function (val) {
              return "{icon|}{ranking| 2}{nice|当前排名：}{val|" + val + "}";
            },
            rich: {
              val: {
                fontSize: "12",
                color: "#1D2129",
                fontWeight: "bold"
              },
              nice: {
                color: "#86909C"
              },
              icon: {
                backgroundColor: {
                  image: riseIcon,
                  height: 16,
                  width: 16
                }
              },
              ranking: {
                padding: [0, 8, 0, 0],
                color: "#FF6E66"
              }
            }
          },
          axisLine: {
            show: false
          },
          offset: -150,
          axisTick: {
            show: false
          }
        }
      ],
      xAxis: {
        type: "value",
        max: 10,
        axisLabel: {
          show: false
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        splitLine: {
          show: false
        }
      },
      series: [
        {
          type: "bar",
          barWidth: 4,
          showBackground: true,
          backgroundStyle: {
            borderRadius: 0,
            color: "#E5E6EB"
          },
          itemStyle: {
            color: "#7983F5",
            borderRadius: 0
          }
        }
      ],
      dataset: {
        dimensions: ["product", "count"],
        source: {
          product: ["空间指标", "用户指标", "能耗指标", "设备指标"],
          count: [8.6, 7.5, 8.6, 8.6]
        }
      },
      tooltip: {
        show: false
      }
    },
    { extend: ["title", "xAxis", "yAxis", "tooltip", "grid"] }
  );
  chart.amount(chartId);
  return chart;
};

export const setLineSingle = function (chartData, chartId, color, unit) {
  let chart = createChart(
    {
      dataset: chartData,
      legend: {
        itemGap: 28,
        itemWidth: 10,
        itemHeight: 1,
        left: "center",
        textStyle: {
          color: "#86909C",
          padding: [0, 0, 0, 6]
        }
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "none"
        },
        formatter(params) {
          return `
          <div class="tooltip-foomatter">
            <div class="date">${params[0].axisValue}</div>
            ${params
              .map((item, index) => {
                return `
                  <div class="item"><div class="icon" style="background-color:${
                    item.color
                  }"></div>${item.seriesName}：
                  ${item.value[index + 1]}</div>
              `;
              })
              .join("")}
            </div>
          `;
        }
      },
      grid: {
        top: 50,
        left: 0,
        right: 50,
        bottom: 40,
        containLabel: true
      },
      dataZoom: {
        type: "slider",
        realtime: true,
        backgroundColor: "#F0F2F5",
        start: 0,
        end: 100,
        bottom: 0,
        height: 24,
        dataBackground: {
          lineStyle: {
            color: "#F0F2F5"
          },
          areaStyle: {
            opacity: 0
          }
        },
        selectedDataBackground: {
          lineStyle: {
            color: "#CED4D9"
          },
          areaStyle: {
            color: "#F0F2F5"
          }
        }
      },
      yAxis: {
        type: "value",
        splitLine: {
          lineStyle: {
            color: "#E5E6EB"
          }
        },
        splitNumber: 5,
        max: 100,
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          color: "#86909C",
          formatter: "{value}" + unit
        }
      },
      xAxis: {
        boundaryGap: false,
        alignTicks: true,
        splitLine: {
          show: false
        },
        axisLabel: {
          color: "#86909C"
        },
        axisTick: {
          show: true,
          length: 4,
          lineStyle: {
            color: "#E5E6EB"
          }
        },
        axisLine: {
          lineStyle: {
            color: "#E5E6EB"
          }
        }
      },
      animation: true,
      series: {
        type: "line",
        smooth: false,
        symbol: "circle",
        symbolSize: 6,
        yAxisIndex: 0,
        itemStyle: {
          color: color
        },
        lineStyle: {
          width: 2,
          cap: "round"
        },
        emphasis: {
          lineStyle: {
            width: 2
          }
        },
        areaStyle: {
          color: "none"
        }
      }
    },
    { extend: ["title", "xAxis", "yAxis", "tooltip", "grid", "legend"] }
  );
  chart.amount(chartId);
  return chart;
};

export const setLinePMV = function (chartData, chartId) {
  let chart = createChart(
    {
      dataset: chartData,
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "none"
        },
        formatter(params) {
          return `
          <div class="tooltip-foomatter">
            <div class="date">${params[0].axisValue}</div>
            ${params
              .map((item, index) => {
                return `
                  <div class="item"><div class="icon" style="background-color:${
                    item.color
                  }"></div>${item.seriesName}：
                  ${item.value[index + 1]}</div>
              `;
              })
              .join("")}
            </div>
          `;
        }
      },
      legend: {
        show: false
      },
      grid: {
        top: 50,
        left: 0,
        right: 50,
        bottom: 40,
        containLabel: true
      },
      yAxis: {
        name: "PMV",
        nameGap: 20,
        nameTextStyle: {
          color: "#86909C"
        },
        type: "value",
        splitLine: {
          lineStyle: {
            color: "#E5E6EB"
          }
        },
        splitNumber: 8,
        max: 2,
        min: -2,
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          color: "#86909C",
          formatter: "{value}"
        }
      },
      xAxis: {
        boundaryGap: false,
        alignTicks: true,
        splitLine: {
          show: false
        },
        axisLabel: {
          color: "#86909C"
        },
        axisTick: {
          show: true,
          length: 4,
          lineStyle: {
            color: "#E5E6EB"
          }
        },
        axisLine: {
          lineStyle: {
            color: "#E5E6EB"
          }
        }
      },
      animation: true,
      series: {
        type: "line",
        smooth: true,
        smoothMonotone: "x",
        symbol: "none",
        itemStyle: {
          color: "#7983F5"
        },
        lineStyle: {
          width: 2,
          cap: "round"
        },
        emphasis: {
          lineStyle: {
            width: 2
          }
        },
        areaStyle: {
          color: "none"
        },
        markLine: {
          symbol: "none",
          silent: true,
          data: [
            {
              name: "X 轴值为 100 的竖直线",
              yAxis: 0
            }
            // { type: "average" }
          ],
          itemStyle: {
            borderWidth: 1,
            textStyle: {
              fontSize: 16,
              fontWeight: "bolder"
            }
          },
          label: {
            formatter: ""
          },
          lineStyle: {
            type: "solid",
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 1,
              y2: 0,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(125, 233, 154, 0.04)" // 0% 处的颜色
                },
                {
                  offset: 0.11,
                  color: "rgba(125, 233, 154, 0.23)"
                },
                {
                  offset: 0.5,
                  color: "rgba(125, 233, 154, 0.32)"
                },
                {
                  offset: 0.89,
                  color: "rgba(125, 233, 154, 0.22)"
                },
                {
                  offset: 1,
                  color: "rgba(125, 233, 154, 0.04)" // 100% 处的颜色
                }
              ],
              globalCoord: false // 缺省为 false
            },
            width: 50
          }
        }
      }
    },
    { extend: ["title", "xAxis", "yAxis", "tooltip", "grid", "legend"] }
  );
  chart.amount(chartId);
  return chart;
};
